import styled from 'styled-components';

export const WarningLabel = styled.p`
  padding: 0 8px;
`;

export const Bold = styled.span`
  font-weight: bold;
`;
